import React from "react";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import Sortable from "./Sortable";

function DraggableTableContent({
  tableData,
  headers,
  keys,
  onDragEnd,
  onEdit,
  onDelete,
  onReorderImages,
}) {
  return (
    <>
      <div
        style={{
          display: "flex",
          border: "2px solid #c8c8c8",
          padding: "8px",
          margin: "4px",
          color: "#000",
          fontWeight: "bold",
          borderRadius: "12px"
        }}
      >
        {headers.map((header) => (
          <div
            key={header}
            style={{ flex: 1, padding: "4px", fontWeight: "bold" }}
          >
            {header}
          </div>
        ))}
      </div>
      <DndContext collisionDetection={closestCenter} onDragEnd={onDragEnd}>
        <SortableContext
          items={tableData.map((item) => item.id)}
          strategy={verticalListSortingStrategy}
        >
          {tableData.map((item) => (
            <Sortable
              key={item.id}
              item={item}
              keys={keys}
              onEdit={onEdit}
              onDelete={onDelete}
              onReorderImages={onReorderImages}
            />
          ))}
        </SortableContext>
      </DndContext>
    </>
  );
}

export default DraggableTableContent;
